import { useState, useRef } from 'react';

interface IDragHandlersProps {
	handleMouseDown: (e: React.MouseEvent) => void;
	handleMouseMove: (e: React.MouseEvent) => void;
	handleMouseUp: () => void;
}

export function useDragScroll(): [
	React.RefObject<HTMLUListElement | null>,
	IDragHandlersProps,
] {
	const containerRef = useRef<HTMLUListElement | null>(null);
	const [isDragging, setIsDragging] = useState(false);
	const [startX, setStartX] = useState(0);
	const [startScrollLeft, setStartScrollLeft] = useState(0);

	const handleMouseDown = (e: React.MouseEvent) => {
		if (!containerRef.current) return;
		setIsDragging(true);
		setStartX(e.pageX - containerRef.current.offsetLeft);
		setStartScrollLeft(containerRef.current.scrollLeft);
	};

	const handleMouseMove = (e: React.MouseEvent) => {
		if (!isDragging || !containerRef.current) return;
		e.preventDefault();
		const x = e.pageX - containerRef.current.offsetLeft;
		const walk = x - startX;
		containerRef.current.scrollLeft = startScrollLeft - walk;
	};

	const handleMouseUp = () => {
		setIsDragging(false);
	};

	return [containerRef, { handleMouseDown, handleMouseMove, handleMouseUp }];
}
